import * as React from 'react';

import styled from '@emotion/styled';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { IconExternalLink } from '@lightspeed/flame/Icon/ExternalLink';
import { TextLink } from '@lightspeed/flame/Text';

const StyledTextLink = styled(TextLink)`
  white-space: nowrap;
`;

interface CustomTextLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  text: string;
  blank?: boolean;
}

export const CustomTextLink: React.FC<CustomTextLinkProps> = ({
  href,
  text,
  blank = false,
  ...rest
}) => {
  if (!href) {
    return null;
  }
  return (
    <StyledTextLink href={href} target={blank ? '_blank' : undefined} {...rest}>
      {text}
      {blank && (
        <>
          {' '}
          <IconExternalLink color={theme.textStyles.link.color} data-test="icon-external" />
        </>
      )}
    </StyledTextLink>
  );
};
